"use client"

import { Button, Text } from "@/elements"
import React, { FC, useCallback } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"

import { LockIcon } from "@/icons/outline"
import { ProBadge } from "@/components/Subscriptions/SubscriptionCheckoutModal/components/ProBadge"
import { ampli } from "@/ampli"

const UpsellCardFragment = graphql(`
  fragment UpsellCard on IndividualCreative {
    __typename
    id

    proMembership {
      id
      activeMembershipType
    }
  }
`)

const RightElement = () => <LockIcon className="size-[22px] stroke-fg-1" />

interface Props {
  creative: FragmentType<typeof UpsellCardFragment> | undefined | null
  handleOpenCheckoutModal: () => void
}

export const UpsellCard: FC<Props> = ({ handleOpenCheckoutModal, ...props }) => {
  const creative = useFragment(UpsellCardFragment, props.creative)

  const hasActiveSubscription = creative?.proMembership?.activeMembershipType !== null

  const handleClick = useCallback(() => {
    ampli.upsellCardClick({
      entry_point: "job-board",
    })
    handleOpenCheckoutModal()
  }, [handleOpenCheckoutModal])

  if (hasActiveSubscription) {
    return null
  }

  return (
    <div
      style={{
        backgroundImage: "url(https://d201dxmsht1mhv.cloudfront.net/main-pro-background-asset.png)",
      }}
      className="flex w-full cursor-pointer flex-col rounded-xl bg-bg-4 bg-cover bg-[0%_40%] p-6 transition-all duration-300 hover:shadow-[0px_4px_24px_0px_rgba(0,0,0,0.10)]"
      onClick={handleClick}>
      <div>
        <ProBadge />
      </div>
      <Text className="mt-3 max-w-[230px] text-bg-1 md:max-w-none lg:max-w-[230px]" variant="h6">
        Join to get full access to new jobs instantly.
      </Text>
      <div className="mt-4 flex flex-row justify-between">
        <div>
          <Text className="text-pro-gradient" variant="h5">
            18k+ Jobs
          </Text>
          <Text className="text-fg-3" variant="caption">
            IN JUST ONE YEAR
          </Text>
        </div>
        <Button RightElement={RightElement} variant="white" size="medium">
          Unlock Pro
        </Button>
      </div>
    </div>
  )
}
